import { UtilService } from './../../services/util/util.service';
import { environment } from '@environment';
import { StorageService } from '../../services/storage/storage.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SipGuard implements CanActivate {

  constructor(
    private router: Router,
    private storageService: StorageService,
    private util: UtilService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (state.url.split('?')[0].match('portfolio/v2')) {
      return this.checkLoginAndOndemand(route, state);
    }
    return this.checkSip(route, state);
  }

  checkLoginAndOndemand(route, state): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const params = { ...route?.queryParams };
      if (params?.utm_source?.match('internal_impact_calling')) {
        resolve(true);
      }

      const userdata = this.util.getUserData();
      const user = this.util.getUser();
      const ondemandExistSip = Object.values(userdata?.listsubscriptions || {}).find((value: any) => value?.isOnDemandSubscription && value?.status_flag === 1 && !value?.remarks?.match('ondemand'));
      if (user?.user?.isLoggedIn && ondemandExistSip) {
        const paramsString = this.util.objToUrlString(params);
        let url = environment.sipretention_domain;
        if (paramsString && !(this.util.getLengthToMultiply(params?.sip_cause) > 1)) {
          url = url + '?' + paramsString;
        }
        if (!this.storageService.getFromSession('sipUserRedirect')) {
          this.storageService.addSessionData('sipUserRedirect', true);
        }
        this.util.nativeNavigation(url);
        resolve(false);
        return;
      }
      resolve(true);
    });
  }

  checkSip(route, state): any {
    const query_param = { ...this.util.actRoute.snapshot.queryParams };
    const paramsString = this.util.objToUrlString(query_param);

    return new Promise((resolve, reject) => {
      try {
        const userdata = this.util.getUserData();
        if (route?.queryParams?.utm_source?.match('internal_impact_calling') || (this.util?.getActiveSip(userdata?.listsubscriptions)?.length === 1 && userdata?.listsubscriptions?.insurance)) {
          resolve(true);
          return;
        }
        const user = this.util.getUser();
        const status_flag = this.util.checkForActiveSip(userdata?.listsubscriptions);
        if ([1, 2, 4, 5].includes(status_flag)) {
          let url = environment.sipretention_domain;
          if (paramsString && !(this.util.getLengthToMultiply(query_param?.sip_cause) > 1)) {
            url = url + '?' + paramsString;
          }
          if (user && user.user && user.user.isLoggedIn) {
            if (!this.storageService.getFromSession('sipUserRedirect')) {
              this.storageService.addSessionData('sipUserRedirect', true);
            }
            if (route.queryParams.utm_source === 'external_ct' && this.util.isMobile()) {
              this.router.navigate(['/new/download-page'], { queryParams: { 'redirect_uri': url } });
              reject(false);
            }
            this.util.nativeNavigation(url);
          } else {
            if (route.queryParams.utm_source === 'external_ct' && this.util.isMobile()) {
              this.router.navigate(['/new/download-page'], { queryParams: { 'redirect_uri': url } });
              reject(false);
            }
            const qPrams = Object.assign({ redirect_uri: state.url.split('?')[0] }, state.root.queryParams);
            this.router.navigate(['/new/signin'], { queryParams: qPrams });
          }
        } else {
          resolve(true);
        }
      } catch (error) {
        reject(false);
      }
    });
  }
}
